import { render, staticRenderFns } from "./confirm-demo-booking.vue?vue&type=template&id=707bd4d4&scoped=true&"
import script from "./confirm-demo-booking.vue?vue&type=script&lang=js&"
export * from "./confirm-demo-booking.vue?vue&type=script&lang=js&"
import style0 from "./confirm-demo-booking.vue?vue&type=style&index=0&id=707bd4d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bd4d4",
  null
  
)

export default component.exports